import React from "react";

import ContentCore from "../../../../core/workingContent";

import "../../_index.css";

const TaskEndTodayReceiverUI = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskEndTodayReceiverUI;
